"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import WaveMutedNotificationButton from "./wave-notification-settings/WaveMutedNotificationButton";
import WaveNotificationPreferenceButtons from "./wave-notification-settings/WaveNotificationPreferenceButtons";
import WaveNotificationRetryButton from "./wave-notification-settings/WaveNotificationRetryButton";
import { useWaveNotificationSettings } from "./wave-notification-settings/useWaveNotificationSettings";
interface WaveRatingProps {
  readonly wave: ApiWave;
  readonly compact?: boolean | undefined;
}
export default function WaveNotificationSettings(t0) {
  const $ = _c(11);
  const {
    wave,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const settings = useWaveNotificationSettings(wave);
  if (!settings.following) {
    return null;
  }
  if (settings.isMuted) {
    let t2;
    if ($[0] !== compact || $[1] !== settings || $[2] !== wave.id) {
      t2 = <WaveMutedNotificationButton waveId={wave.id} settings={settings} compact={compact} />;
      $[0] = compact;
      $[1] = settings;
      $[2] = wave.id;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (settings.preferencesUnavailable) {
    let t2;
    if ($[4] !== compact || $[5] !== settings) {
      t2 = <WaveNotificationRetryButton settings={settings} compact={compact} />;
      $[4] = compact;
      $[5] = settings;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  let t2;
  if ($[7] !== compact || $[8] !== settings || $[9] !== wave.id) {
    t2 = <WaveNotificationPreferenceButtons waveId={wave.id} settings={settings} compact={compact} />;
    $[7] = compact;
    $[8] = settings;
    $[9] = wave.id;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}